'use client';

// Third Party Plugins
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { FieldValues, SubmitHandler } from 'react-hook-form';
import queryString from 'query-string';
// Utilities
import netlifyDataEncoder from '@utils/netlifyDataEncoder';
// Styles
import { StyledForm, StyledFormContent, StyledFormRow } from './styles';
// Custom Components
import FormInput from '@/components/forms/FormInput';
import Button from '@/components/buttons/BaseButton';

const FormComponent: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    const params = queryString.parse(window.location.search);
    if (params.source) {
      setValue('inquiryType', params.source as string);
    }
  }, [setValue]);

  const formSubmit: SubmitHandler<FieldValues> = (formData, e) => {
    const form = e?.target as HTMLFormElement;
    fetch('/__forms.html', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: netlifyDataEncoder({
        'form-name': form.getAttribute('name') || 'join',
        ...formData,
      }),
    })
      .then(() => {
        const action = form.getAttribute('action');
        if (action) {
          window.location.href = action;
        }
      })
      .catch((error) => alert('Form submission failed: ' + error.message));
  };

  return (
    <StyledForm
      name="join"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      action="/thank-you"
      onSubmit={handleSubmit(formSubmit)}
    >
      <input type="hidden" name="form-name" value="join" />
      <StyledFormContent>
        <StyledFormRow>
          <FormInput
            label="First Name*"
            id="firstName"
            register={register}
            type="text"
            errors={errors}
          />
          <FormInput
            label="Last Name*"
            id="lastName"
            register={register}
            type="text"
            errors={errors}
          />
        </StyledFormRow>
        <FormInput
          label="Email*"
          id="email"
          register={register}
          type="email"
          placeholder="info@example.com"
          errors={errors}
        />
        <FormInput
          label="Title*"
          id="title"
          register={register}
          type="text"
          placeholder="Professor, adjunct, admin..."
          errors={errors}
        />
        <FormInput
          label="School*"
          id="school"
          register={register}
          type="text"
          errors={errors}
        />
        <FormInput
          label="Comments"
          id="comments"
          register={register}
          placeholder="Add a message…"
          errors={errors}
          isTextarea
          rows={16}
        />
        <Button type="submit">Submit</Button>
      </StyledFormContent>
    </StyledForm>
  );
};

export default FormComponent;
